import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { AutomationsPage } from 'src/modules/automations/components/pages/automations/automations.page';
import { globalSearchSchema } from 'src/modules/shared/schemas/search.schema';

const automationsSearchSchema = globalSearchSchema.merge(
  z.object({
    phoneVersion: globalSearchSchema.shape.phoneVersion.default('v1' as const),
  })
);

export const Route = createFileRoute('/automations/')({
  component: AutomationsLayoutComponent,
  validateSearch: (search) => automationsSearchSchema.parse(search),
});

function AutomationsLayoutComponent() {
  return (
    <AuthenticateRoute>
      <AutomationsPage />
    </AuthenticateRoute>
  );
}
